import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GAggingReportViewmodel } from 'src/app/viewmodels/g-settings/GAggingReportViewmodel';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
@Component({
  selector: 'app-agging-report',
  templateUrl: './agging-report.component.html',
  styleUrls: ['./agging-report.component.scss']
})
export class AggingReportComponent implements OnInit {

  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  public vmListItems: any = [];
  p: number = 1;
  public component_Title = 'Agging Report';
  public client: any;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.spinner.show();
    this._uow.gReportingService.GetAggingReportAsync().subscribe((res: any) => {
      debugger
      this.vmListItems = res;
      
      this.spinner.hide();
      // this._jq.showSpinner();
    }, (err) => {
      console.log(err);
      // this._jq.showSpinner();
      this.spinner.hide();

    });
  }

}
